import { App } from "vue";
import Freshchat from "./Freshchat.vue";

interface FreshchatOptions {
  appToken: string;
  host: string;
}

function _defineProperty(obj: any, key: PropertyKey, value: any) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object: Record<string, never>, enumerableOnly?: boolean) {
  let keys: string[] = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    let symbols = Object.getOwnPropertySymbols(object).map(value =>
      value.toString()
    );
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym)?.enumerable;
      });
    keys = [...keys, ...symbols];
  }

  return keys;
}

function _objectSpread2(target: any, ...args: any[]) {
  for (let i = 1; i < args.length; i++) {
    const source: never | Record<string, never> =
      args[i] != null ? args[i] : {};

    if (i % 2 && Object.keys(source).length > 0) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(
          target,
          key,
          Object.getOwnPropertyDescriptor(source, key) || {}
        );
      });
    }
  }

  return target;
}

const callIf = function(a: boolean, f: () => void) {
  return a && f();
};
const assert = function assert(condition: any, msg: string) {
  return callIf(!condition, function() {
    throw new Error("[vue-freshchat] ".concat(msg));
  });
};

let App: App;

const getFreshchatInstance = function(_ref: FreshchatOptions) {
  const appToken = _ref.appToken,
    host = _ref.host;
  assert(App, "call Vue.use(VueFreshchat) before creating an instance");
  App.component("Freshchat", Freshchat);
  const freshchat: any = {
    _vm: App.component("Freshchat"),
    _init: function() {
      this._vm.ready = true;

      freshchat._boot();
    },
    _boot: function() {
      window.fcWidget.init({
        token: appToken,
        host:
          host !== null && host !== void 0
            ? host
            : "https://wchat.freshchat.com"
      });
      window.fcWidget.setExternalId(this._vm.externalId);
      //window.fcWidget.user.setMeta(this._vm.user);
      window.fcWidget.on("widget:opened", () => {
        this._vm.isOpen = true;
      });
      window.fcWidget.on("widget:closed", () => {
        this._vm.isOpen = false;
      });
      this._vm.dom = document.querySelector("#fc_frame");
    },
    setExternalId: function(externalId: string) {
      this._vm.externalId = externalId;
      if (!this._vm.ready) return;
      window.fcWidget.setExternalId(this._vm.externalId);
    },
    setUserProperties: function(...args: never[]) {
      const user = args.length > 0 && args[0] !== undefined ? args[0] : {};
      this._vm.user = _objectSpread2(_objectSpread2({}, this._vm.user), user);
      if (!this._vm.ready) return;
      window.fcWidget.user.setProperties(this._vm.user);
    },
    open: function(payload: Record<string, never>) {
      if (!this._vm.ready) return;
      window.fcWidget.open(payload);
    },
    close: function() {
      if (!this._vm.ready) return;
      window.fcWidget.close();
    },
    toggle: function() {
      const isOpen = this._vm.isOpen;

      if (isOpen) {
        freshchat.close();
      } else {
        freshchat.open();
      }
    },
    hideWidget: function() {
      this._vm.hideWidget = true;
    },
    showWidget: function() {
      this._vm.hideWidget = false;
    }
  };

  return freshchat;
};

export const VueFreshchat = {
  installed: false,
  loadScript() {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://wchat.freshchat.com/js/widget.js";
    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode?.insertBefore(script, firstScript);
  },
  install(_App: App, _ref2: FreshchatOptions) {
    const appToken = _ref2.appToken,
      host = _ref2.host;
    assert(!App, "already installed.");
    App = _App;
    App.config.globalProperties.$freshchat = getFreshchatInstance({
      appToken: appToken,
      host: host
    });
    if (document.readyState === "complete") {
      this.loadScript();
    } else {
      window.addEventListener("load", () => this.loadScript(), false);
    }
  }
};
